import { Euro } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Alert, Button, InputAdornment, MenuItem, Stack, TextField } from "@mui/material";
import { useState } from "react";
import API from "../../services/API";
import Toggle from "../Inputs/Toggle";

export default function ProductForm({product, onSuccess, onClose}){

    const [data, setData] = useState(product)

    const [status, setStatus] = useState('ready')

    const handleSubmit = e => {

        e.preventDefault();

        setStatus('submit')

        saveProduct(data)
            .then(r => {
                setStatus('ready')
                console.log(r.data)
                onSuccess(r.data)
                onClose()
            })
            .catch(e => {
                console.error(e.response?.data)
                setStatus('error')
            })
        
    }

    return data && <form onSubmit={handleSubmit}>

        <Stack spacing={2} sx={{maxWidth: 500, margin: 'auto', pt: 3}}>

            {status === 'error' &&
                <Alert severity='error'>Une erreur s'est produite</Alert>
            }

            <TextField 
                label="Libellé du tarif"
                value={data.title}
                onChange={e => setData({...data, title: e.target.value})}
                inputProps={{maxLength: 200}}
                required
                size='small'
            />

            <TextField
                label="Prix HT"
                type="number"
                value={data.price}
                onChange={e => setData({...data, price: priceValue(e.target.value)})}
                size='small'
                InputProps={{
                    endAdornment: 
                        <InputAdornment position="end">
                            <Euro />
                        </InputAdornment>
                }}
                inputProps={{min: 0, step: 0.01}}
                required
            />

            <TextField
                label="Taux de TVA"
                value={data.taxRate.toFixed(3)}
                onChange={e => setData({...data, taxRate: parseFloat(e.target.value)})}
                select
                required
                size='small'
            >
                <MenuItem value='0.000'>0%</MenuItem>
                <MenuItem value='0.055'>5.5%</MenuItem>
                <MenuItem value='0.100'>10%</MenuItem>
                <MenuItem value='0.200'>20%</MenuItem>
            </TextField>

            {data.type?.id === 'event' &&

                <Toggle 
                    label="Définir un quota de places disponibles"
                    value={data.stock ? true : false}
                    onChange={(_,v) => setData({...data, stock:
                        v ? {initial: ''} : null
                    })}
                />
            }

            {data.stock &&

                <TextField
                    label="Nombre de places disponibles"
                    type="number"
                    value={data.stock.initial}
                    onChange={e => setData({...data, stock: 
                        {...data.stock, initial: stockValue(e.target.value)}
                    })}
                    size='small'
                    inputProps={{min: 0, step: 1, max: 100000}}
                    required
                />
            }

            <Stack direction='row' justifyContent='flex-end' spacing={2}>

                <Button onClick={onClose}>
                    Annuler
                </Button>

                <LoadingButton
                    type='submit'
                    loading={status === 'submit'}
                    variant='contained'
                >
                    Valider
                </LoadingButton>

            </Stack>

        </Stack>

    </form>
}

const priceValue = val => val !== '' ? Math.round(parseFloat(val || 0) * 100) / 100 : ''

const stockValue = val => val !== '' ? Math.round(parseFloat(val || 0)) : ''

const saveProduct = async product => product.id ? 
    await API.put(`/products/${product.id}`, product) : 
    await API.post(`/products`, product)